var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 21.75H14C19.43 21.75 21.75 19.43 21.75 14V8C21.75 2.57 19.43 0.25 14 0.25H8C2.57 0.25 0.25 2.57 0.25 8V14C0.25 19.43 2.57 21.75 8 21.75ZM14 1.75C18.61 1.75 20.25 3.39 20.25 8V14C20.25 18.61 18.61 20.25 14 20.25H8C3.39 20.25 1.75 18.61 1.75 14V8C1.75 3.39 3.39 1.75 8 1.75H14Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74008 15.28C9.93008 15.28 10.1201 15.21 10.2701 15.06L13.8001 11.53C14.0901 11.24 14.0901 10.76 13.8001 10.47L10.2701 6.93997C9.98008 6.64997 9.50008 6.64997 9.21008 6.93997C8.92008 7.22997 8.92008 7.70997 9.21008 7.99997L12.2101 11L9.21008 14C8.92008 14.29 8.92008 14.77 9.21008 15.06C9.35008 15.21 9.54008 15.28 9.74008 15.28Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.f4bbda7cf7d2a326be8795ee355c25f7.svg";
export { ForwardRef as ReactComponent };